import { createContext } from "react";
import type { ViewModelClasses } from "./types";

/**
 * This is a context used to provide view model classes in production. It is also used for mocking view models with dependency injection in storybook.
 */
export const viewModelClassesContext = createContext<ViewModelClasses>({});
